import { createContext, useContext } from 'react';

export const PanZoomContext = createContext();
export const usePanZoomContext = () => useContext(PanZoomContext);
